import { _ as Fe } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import { g as ve, E as je, M as ze, t as Pe, N as Re, O as _e, _ as X, f as L, D as M, F as ke, a2 as Be, X as Ae, u as Le, b as de, s as Ne, n as Te, p as Ge, C as Ve, l as me, d as he, e as We, q as qe } from "./export-cdcbfb2b.js";
import { b as Ke } from "./create-property-f9780ed1.js";
import { e as Xe, i as Me, c as Qe } from "./es.object.from-entries-0d7a0e54.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import { f as Ue } from "./es.object.to-string-f55666a8.js";
import { o as Je } from "./object-get-own-property-names-external-2f8b4cc4.js";
import { s as pe, d as ge } from "./iterate-13ada9e5.js";
import { a as Ie } from "./an-instance-6efcfd6c.js";
import { c as Ze } from "./check-correctness-of-iteration-7d57c70c.js";
import { i as Ce } from "./inherit-if-required-f068457b.js";
import { o as He } from "./object-create-9b6715a2.js";
import { d as Ye } from "./define-built-in-accessor-26bc7b69.js";
import { s as er } from "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import { d as rr, a as tr } from "./web.dom-collections.for-each-3020ed11.js";
import { ThemeName as z, fpds as P, fcds as R, useTheme as nr } from "@ucl/shared-component-foundations";
import { FordProIcons as $e, FordCreditIcons as be, ExtendedSizes as C, Sizes as H } from "@ucl/shared-icons";
import { c as Y } from "./index-8b07dec9.js";
import ee from "react";
import ar from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import { g as ir } from "./getMetrics-953aa4f8.js";
import { jsx as re } from "react/jsx-runtime";
var te = ve, ye = rr, or = tr, j = Xe, ne = ze, sr = pe, lr = je, T = lr("iterator"), G = j.values, xe = function(e, r) {
  if (e) {
    if (e[T] !== G)
      try {
        ne(e, T, G);
      } catch {
        e[T] = G;
      }
    if (sr(e, r, !0), ye[r]) {
      for (var l in j)
        if (e[l] !== j[l])
          try {
            ne(e, l, j[l]);
          } catch {
            e[l] = j[l];
          }
    }
  }
};
for (var V in ye)
  xe(te[V] && te[V].prototype, V);
xe(or, "DOMTokenList");
var fr = Pe, ae = _e, cr = Re, ur = function(r) {
  for (var l = fr(this), u = cr(l), v = arguments.length, f = ae(v > 1 ? arguments[1] : void 0, u), n = v > 2 ? arguments[2] : void 0, d = n === void 0 ? u : ae(n, u); d > f; )
    l[f++] = r;
  return l;
}, vr = X, dr = ur, mr = Ke;
vr({ target: "Array", proto: !0 }, {
  fill: dr
});
mr("fill");
var Se = { exports: {} }, hr = L, pr = hr(function() {
  if (typeof ArrayBuffer == "function") {
    var e = new ArrayBuffer(8);
    Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
  }
}), gr = L, Ir = M, $r = ke, ie = pr, A = Object.isExtensible, br = gr(function() {
  A(1);
}), yr = br || ie ? function(r) {
  return !Ir(r) || ie && $r(r) === "ArrayBuffer" ? !1 : A ? A(r) : !0;
} : A, xr = L, Sr = !xr(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), wr = X, Dr = de, Or = Ae, Er = M, Q = Ne, Fr = Le.f, oe = Te, jr = Je, U = yr, zr = Be, Pr = Sr, we = !1, y = zr("meta"), Rr = 0, J = function(e) {
  Fr(e, y, { value: {
    objectID: "O" + Rr++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, _r = function(e, r) {
  if (!Er(e))
    return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
  if (!Q(e, y)) {
    if (!U(e))
      return "F";
    if (!r)
      return "E";
    J(e);
  }
  return e[y].objectID;
}, kr = function(e, r) {
  if (!Q(e, y)) {
    if (!U(e))
      return !0;
    if (!r)
      return !1;
    J(e);
  }
  return e[y].weakData;
}, Br = function(e) {
  return Pr && we && U(e) && !Q(e, y) && J(e), e;
}, Ar = function() {
  Lr.enable = function() {
  }, we = !0;
  var e = oe.f, r = Dr([].splice), l = {};
  l[y] = 1, e(l).length && (oe.f = function(u) {
    for (var v = e(u), f = 0, n = v.length; f < n; f++)
      if (v[f] === y) {
        r(v, f, 1);
        break;
      }
    return v;
  }, wr({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: jr.f
  }));
}, Lr = Se.exports = {
  enable: Ar,
  fastKey: _r,
  getWeakData: kr,
  onFreeze: Br
};
Or[y] = !0;
var De = Se.exports, Nr = X, Tr = ve, Gr = de, se = Ge, Vr = he, Wr = De, qr = ge, Kr = Ie, Xr = Ve, Mr = me, W = M, q = L, Qr = Ze, Ur = pe, Jr = Ce, Zr = function(e, r, l) {
  var u = e.indexOf("Map") !== -1, v = e.indexOf("Weak") !== -1, f = u ? "set" : "add", n = Tr[e], d = n && n.prototype, a = n, c = {}, t = function(m) {
    var g = Gr(d[m]);
    Vr(
      d,
      m,
      m === "add" ? function(h) {
        return g(this, h === 0 ? 0 : h), this;
      } : m === "delete" ? function(I) {
        return v && !W(I) ? !1 : g(this, I === 0 ? 0 : I);
      } : m === "get" ? function(h) {
        return v && !W(h) ? void 0 : g(this, h === 0 ? 0 : h);
      } : m === "has" ? function(h) {
        return v && !W(h) ? !1 : g(this, h === 0 ? 0 : h);
      } : function(h, $) {
        return g(this, h === 0 ? 0 : h, $), this;
      }
    );
  }, s = se(
    e,
    !Xr(n) || !(v || d.forEach && !q(function() {
      new n().entries().next();
    }))
  );
  if (s)
    a = l.getConstructor(r, e, u, f), Wr.enable();
  else if (se(e, !0)) {
    var i = new a(), o = i[f](v ? {} : -0, 1) !== i, p = q(function() {
      i.has(1);
    }), x = Qr(function(m) {
      new n(m);
    }), E = !v && q(function() {
      for (var m = new n(), g = 5; g--; )
        m[f](g, g);
      return !m.has(-0);
    });
    x || (a = r(function(m, g) {
      Kr(m, d);
      var I = Jr(new n(), m, a);
      return Mr(g) || qr(g, I[f], { that: I, AS_ENTRIES: u }), I;
    }), a.prototype = d, d.constructor = a), (p || E) && (t("delete"), t("has"), u && t("get")), (E || o) && t(f), v && d.clear && delete d.clear;
  }
  return c[e] = a, Nr({ global: !0, constructor: !0, forced: a !== n }, c), Ur(a, e), v || l.setStrong(a, e, u), a;
}, Cr = he, Hr = function(e, r, l) {
  for (var u in r)
    Cr(e, u, r[u], l);
  return e;
}, le = He, Yr = Ye, fe = Hr, et = Ue, rt = Ie, tt = me, nt = ge, at = Me, _ = Qe, it = er, F = qe, ce = De.fastKey, Oe = We, ue = Oe.set, K = Oe.getterFor, ot = {
  getConstructor: function(e, r, l, u) {
    var v = e(function(c, t) {
      rt(c, f), ue(c, {
        type: r,
        index: le(null),
        first: null,
        last: null,
        size: 0
      }), F || (c.size = 0), tt(t) || nt(t, c[u], { that: c, AS_ENTRIES: l });
    }), f = v.prototype, n = K(r), d = function(c, t, s) {
      var i = n(c), o = a(c, t), p, x;
      return o ? o.value = s : (i.last = o = {
        index: x = ce(t, !0),
        key: t,
        value: s,
        previous: p = i.last,
        next: null,
        removed: !1
      }, i.first || (i.first = o), p && (p.next = o), F ? i.size++ : c.size++, x !== "F" && (i.index[x] = o)), c;
    }, a = function(c, t) {
      var s = n(c), i = ce(t), o;
      if (i !== "F")
        return s.index[i];
      for (o = s.first; o; o = o.next)
        if (o.key === t)
          return o;
    };
    return fe(f, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var t = this, s = n(t), i = s.first; i; )
          i.removed = !0, i.previous && (i.previous = i.previous.next = null), i = i.next;
        s.first = s.last = null, s.index = le(null), F ? s.size = 0 : t.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(c) {
        var t = this, s = n(t), i = a(t, c);
        if (i) {
          var o = i.next, p = i.previous;
          delete s.index[i.index], i.removed = !0, p && (p.next = o), o && (o.previous = p), s.first === i && (s.first = o), s.last === i && (s.last = p), F ? s.size-- : t.size--;
        }
        return !!i;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(t) {
        for (var s = n(this), i = et(t, arguments.length > 1 ? arguments[1] : void 0), o; o = o ? o.next : s.first; )
          for (i(o.value, o.key, this); o && o.removed; )
            o = o.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(t) {
        return !!a(this, t);
      }
    }), fe(f, l ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(t) {
        var s = a(this, t);
        return s && s.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(t, s) {
        return d(this, t === 0 ? 0 : t, s);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(t) {
        return d(this, t = t === 0 ? 0 : t, t);
      }
    }), F && Yr(f, "size", {
      configurable: !0,
      get: function() {
        return n(this).size;
      }
    }), v;
  },
  setStrong: function(e, r, l) {
    var u = r + " Iterator", v = K(r), f = K(u);
    at(e, r, function(n, d) {
      ue(this, {
        type: u,
        target: n,
        state: v(n),
        kind: d,
        last: null
      });
    }, function() {
      for (var n = f(this), d = n.kind, a = n.last; a && a.removed; )
        a = a.previous;
      return !n.target || !(n.last = a = a ? a.next : n.state.first) ? (n.target = null, _(void 0, !0)) : _(d === "keys" ? a.key : d === "values" ? a.value : [a.key, a.value], !1);
    }, l ? "entries" : "values", !l, !0), it(r);
  }
}, st = Zr, lt = ot;
st("Set", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, lt);
var S = /* @__PURE__ */ function(e) {
  return e.DEFAULT = "default", e.DANGER = "danger", e.SUCCESS = "success", e.ONCOLOR = "oncolor", e;
}({}), ft = ["icon", "size", "extended", "color", "hidden", "className"], k, D, O, B, ct = (k = {}, k[z.FORD_PRO] = $e, k[z.FORD_CREDIT] = be, k), Ee = Object.assign({}, be, $e), ut = (B = {}, B[z.FORD_PRO] = (D = {}, D[S.DEFAULT] = P.semantic.color.fill.primaryStrong, D[S.DANGER] = P.semantic.color.fill.dangerStrong, D[S.SUCCESS] = P.semantic.color.fill.successStrong, D[S.ONCOLOR] = P.semantic.color.fill.default, D), B[z.FORD_CREDIT] = (O = {}, O[S.DEFAULT] = R.semanticMode1.color.fill.onLight.interactive.value, O[S.DANGER] = R.semanticMode1.color.icon.onDark.danger.value, O[S.SUCCESS] = R.semanticMode1.color.fill.onLight.successStrong.value, O[S.ONCOLOR] = R.primitive.color.twilight[800].value, O), B), vt = /* @__PURE__ */ ar.span.withConfig({
  displayName: "Icon__StyledSVGSpan",
  componentId: "sc-6n6xls-0"
})(["&.Icon{", ";}"], function(e) {
  var r = e.color, l = r === void 0 ? "currentColor" : r, u = e.$width, v = u === void 0 ? "fit-content" : u, f = e.$height, n = f === void 0 ? "fit-content" : f;
  return (
    /* css */
    `
      display: inline-blok;
      width: var(--svg-width, var(--svg-size, ` + v + `));
      height: var(--svg-height, var(--svg-size, ` + n + `));
      color: var(--svg-color, ` + l + `);

      div {
        display: contents;
      }
      
      svg {
        width: 100%;
        height: 100%;
        color: inherit;
      }
    `
  );
}), dt = function(r) {
  var l, u, v, f, n, d, a = r.icon, c = r.size, t = r.extended, s = r.color, i = r.hidden, o = r.className, p = Fe(r, ft), x = nr(), E = x.themeName, m = E === void 0 ? z.FORD_CREDIT : E, g = x.icons, I = ir({
    label: "Icon"
  });
  if (!a || i)
    return null;
  var h = {
    $icon: !!a && (typeof a == "string" || /* @__PURE__ */ ee.isValidElement(a) ? a : a[m]),
    iconSize: c ? typeof c == "string" ? c : c[m] : void 0,
    isExtended: !!t && (typeof t == "boolean" ? t : t[m]),
    iconColor: ((l = ut[m]) == null ? void 0 : l[s]) || s
  }, $ = h.$icon, b = h.iconSize, N = h.isExtended, w = h.iconColor;
  if (!$)
    return null;
  if (typeof $ != "string" && /* @__PURE__ */ ee.isValidElement($))
    return /* @__PURE__ */ re(vt, Object.assign({}, p, {
      $width: (u = p.width) != null ? u : N ? C[b || "s"] : H[b || "l"],
      $height: ((v = p.height) != null ? v : N) ? C[b || "s"] : H[b || "l"],
      color: w,
      className: Y(["Icon", "Icon--" + a, (f = {}, f["Icon--" + w] = w, f["Icon--" + b] = b, f), o]),
      children: $
    }));
  var Z = (g == null ? void 0 : g[$]) || ((n = ct[m]) == null ? void 0 : n[$]) || Ee[$];
  return Z ? /* @__PURE__ */ re(Z, Object.assign({}, I, p, {
    className: Y(["Icon", "Icon--" + $, (d = {}, d["Icon--" + w] = w, d["Icon--" + b] = b, d), o]),
    extended: N,
    size: b,
    color: w
  })) : null;
};
dt.Names = [].concat(new Set(Object.keys(Ee)));
export {
  ct as I,
  dt as a,
  S as b,
  Hr as d
};
